// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YkfH","title":"Header_title__1l8dJ","left":"Header_left__2aXQ7","clinicName":"Header_clinicName__3s9H_"};